module.exports = __webpack_public_path__ + "img/250.1965bd84.jpg";